export function addCurrent(hirer) {
    return {
        type: 'ADD_CURRENT_HIRER',
        hirer,
    }
}